export default __webpack_public_path__ + "static/media/donuts.ae5db3b4.jpg";